import Vue from 'vue'
import store from '@/store'

export function valueName (value, className) {
  if (!store.state.user.token) return null

  if (!className) {
    if (value instanceof Array) {
      return value.join(',')
    }
    return value
  }

  switch (className) {
    case 'Date':
      return value.format('yyyy-MM-dd')

    case 'Datetime':
      return value.format('yyyy-MM-dd hh:mm:ss')
  }

  const nameMap = store.state.data.nameMap[className]
  const codeNameMap = store.state.data.codeNameMap[className]

  if (!nameMap) {
    store.dispatch('data/kvList', className)

    return null
  }

  switch (className) {
    case 'BrandModel':
      if (value instanceof Array) return (nameMap[value[0]] + ' / ' + value[1])
      break
  }

  if (value instanceof Array) return value.map(item => (codeNameMap[item] || nameMap[item])).join(',')
  return codeNameMap[value] || nameMap[value] || value
}

Vue.filter('valueName', function (value, className) {
  return valueName(value, className)
})

Vue.filter('status', function (value) {
  return valueName(value, 'Status')
})

Vue.filter('trim', function (value) {
  return (value || '').split('/')[0]
})

Vue.filter('carNo', function (value) {
  if (!value) return ''
  return value.substr(0, 1) + ' ' + value.substr(1)
})
